import { SIGN_IN, UPDATE_USER, SIGN_OUT, SESSION_TYPE, ACTION_TYPE } from './types';


export type SIGN_IN_TYPE = (profile: SESSION_TYPE) => ACTION_TYPE;
export const signIn: SIGN_IN_TYPE = (profile) => ({ type: SIGN_IN, payload: profile });

export const signOut = (): ACTION_TYPE => ({ type: SIGN_OUT });

export const updateUser = (data: SESSION_TYPE): ACTION_TYPE => ({ type: UPDATE_USER, payload: data });
